var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"layout layout--blank"},[_c('nuxt'),_vm._v(" "),_c('system-notifications',{attrs:{"notifications":_vm.notifications}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }